import styled from "styled-components";

export const InputTitle = styled.div`
  font-size: 18px;
  margin-bottom: 10px;
`;

export const InputCtn = styled.div`
  margin-bottom: 50px;
`;